import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/index.vue'
// 左侧tab权限菜单
import { permissionRoute, constRoute } from './permissionRoute.ts'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    meta: { title: '首页', icon: 'dashboard' },
    redirect: { name: '/dashboard' },
    children: permissionRoute,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '介绍',
      noCheck: true,
      noHistory: true,
    },
  },
  {
    path: '/loginPage',
    name: 'loginPage',
    component: () => import('@/views/login/loginPage.vue'),
    meta: {
      title: '登录',
      noCheck: true,
      noHistory: true,
    },
  },
  {
    path: '/:path(.*)',
    name: '404',
    component: () => import('@/views/error/404.vue'),
    meta: {
      noHistory: true,
      noCheck: true,
    },
  },
  {
    path: '/noPermission',
    name: 'noPermission',
    component: () => import('@/views/error/noPermission.vue'),
    meta: {
      noHistory: true,
      noCheck: true,
    },
  },
  {
    path: '/redirect/:path(.*)',
    name: 'redirect',
    component: () => import('@/common/redirectPage.vue'),
    meta: {
      noCheck: true,
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/common/privacyPage.vue'),
    meta: {
      noHistory: true,
      noCheck: true,
    },
  },
]

export default routes
